export const TILES = Object.freeze([
  {
    key: 'ezi',
    bg: '/static/images/tiles/ezi-tile-bg.png',
    logo: '/static/images/tiles/ezi-logo.png',
    title: 'Ezi Car Rental – Business mobility made easy',
    contentImage: '/static/images/tiles/ezi-content.png',
    description:
      'Flexible vehicle solutions for businesses, with 24 locations NZ-wide, a modern fleet, and local support. Partner with us for reliable, scalable mobility tailored to your needs.',
    dark: true,
    backgroundPosition: 'top',
  },
  {
    key: 'z-energy',
    bg: '/static/images/tiles/z-tile-bg.png',
    logo: '/static/images/tiles/z-logo.png',
    title: 'Z Card - Apply for Z Business now',
    contentImage: '/static/images/tiles/z-content.png',
    description:
      'Put the brakes on fuel costs, and save with the Z Business Card.',
    dark: false,
    backgroundPosition: 'center',
  },
  {
    key: 'cityhop',
    bg: '/static/images/tiles/cityhop-tile-bg.png',
    logo: '/static/images/tiles/cityhop-logo.png',
    title: 'Cityhop – Mobility that works for Business',
    contentImage: '/static/images/tiles/cityhop-content.png',
    description:
      'Cut your transport costs with flexible, pay-as-you-go car sharing. No deposits or membership fees, just book via the app and pay for time and distance used. Smarter, more sustainable business travel.',
    dark: true,
    backgroundPosition: 'top',
  },
  {
    key: 'geotab',
    bg: '/static/images/tiles/geotab-tile-bg.png',
    logo: '/static/images/tiles/geo-logo.png',
    title: 'Smarter fleet management with Geotab',
    contentImage: '/static/images/tiles/geo-content.png',
    description:
      'Geotab delivers real-time GPS tracking, smart vehicle insights, and seamless integrations, helping fleets boost safety, efficiency, and growth with trusted data.',
    dark: false,
    backgroundPosition: 'center',
  },
])

export const servicesCatalog = [
  {
    id: 'Ezi',
    label: 'Ezi Car Rental',
    imageSrc: '/static/images/tiles/ezi-tile-bg.png',
    logoSrc: '/static/images/tiles/ezi-logo.png',
  },
  {
    id: 'CityHop',
    label: 'Cityhop',
    imageSrc: '/static/images/tiles/cityhop-tile-bg.png',
    logoSrc: '/static/images/tiles/cityhop-logo.png',
  },
  {
    id: 'FuelCard',
    label: 'Z Energy',
    imageSrc: '/static/images/tiles/z-tile-bg.png',
    logoSrc: '/static/images/tiles/z-logo.png',
  },
  {
    id: 'GeoTab',
    label: 'Geotab',
    imageSrc: '/static/images/tiles/geotab-tile-bg.png',
    logoSrc: '/static/images/tiles/geo-logo.png',
  },
]
